import { useQuery } from '@tanstack/react-query';
import { getStoreProductsFacets } from '@/services/search';
import useFilters, { ShopFilters } from '../Shop/hooks/useFilters';

export function getFindFacetsQueryOptions(filters: Omit<ShopFilters, 'page'>) {
  return {
    queryKey: ['facets', filters],
    queryFn: () => getStoreProductsFacets(filters),
    staleTime: 0,
    initialData: {
      categories: [],
      subcategories: [],
      countries: [],
      regions: [],
      occasions: [],
      characteristics: [],
      serviceTemperatures: [],
      prices: [],
      tags: [],
    },
  };
}

export function getFindCategoriesQueryOptions(params: {
  hash: string;
  deliveryType?: string;
}) {
  return {
    queryKey: ['categories', params],
    queryFn: () => getStoreProductsFacets(params),
    staleTime: 0,
  };
}

export function useFindCategoriesQuery() {
  const {
    filters: { hash, deliveryType },
  } = useFilters();
  return useQuery(getFindCategoriesQueryOptions({ hash, deliveryType }));
}

export function useFindFacetsQuery() {
  const {
    filters: { page, ...rest },
  } = useFilters();
  return useQuery(getFindFacetsQueryOptions(rest));
}
